import { Component, OnInit } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';

@Component({
    selector: 'cv-systemplate-action-cell-renderer',
    templateUrl: './systemplate-action-cell-renderer.component.html',
    styleUrls: ['./systemplate-action-cell-renderer.component.scss']
})
export class SysTemplateActionCellRendererComponent implements AgRendererComponent {
    params: ICellRendererParams;

    constructor(public config: CvConfigurationService) { }

    agInit(params: ICellRendererParams) {
        this.params = params;
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        return true;
    }

    contextMenuClick(e: MouseEvent) {
        this.params.api['contextMenuFactory'].showMenu(this.params.node, this.params.columnApi.getColumn("Actions"), this.params.value, e);
    }

}
